import { fetchWithAuth } from "../utils/apiUtils";

export default class MonitorService {
    private static monitorPath = 'job/monitors';

    constructor() { }

    public static async getMonitors() {
        return await fetchWithAuth(this.monitorPath, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async addMonitor(data: any) {
        return await fetchWithAuth(this.monitorPath, {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    public static async getMonitor(id: string) {
        return await fetchWithAuth(`${this.monitorPath}/${id}`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async updateMonitor(id: string, data: any) {
        return await fetchWithAuth(`${this.monitorPath}/${id}`, {
            method: 'PATCH',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    public static async addCondition(monitorId: string, data: any) {
        return await fetchWithAuth(`${this.monitorPath}/${monitorId}/conditions`, {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    public static async getCondition(monitorId: string, conditionId: string) {
        return await fetchWithAuth(`${this.monitorPath}/${monitorId}/conditions/${conditionId}`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async updateCondition(monitorId: string, conditionId: string, data: any) {
        return await fetchWithAuth(`${this.monitorPath}/${monitorId}/conditions/${conditionId}`, {
            method: 'PATCH',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data)
        });
    }
}